/**
 * Navegación móvil — la principal, porque esta app se usa en el teléfono.
 *
 * Antes: 4 destinos + un botón «+» que abría una hoja con DIECISÉIS enlaces,
 * lo cual no es un menú de acciones sino el mapa del sitio disfrazado.
 *
 * Ahora el «+» hace una sola cosa: preguntar qué pasó con tu dinero. Los
 * destinos secundarios viven en «Más», que es un destino, no una emboscada.
 */
import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Plus, MoreHorizontal } from "lucide-react";
import { MAIN_NAV } from "@/components/Sidebar";
import MoreSheet from "@/components/MoreSheet";

export default function BottomNav() {
  const loc = useLocation();
  const [more, setMore] = useState(false);
  const [left, right] = [MAIN_NAV.slice(0, 2), MAIN_NAV.slice(2)];

  const item = ({ to, label, icon: Icon, tid }) => {
    const active = to === "/" ? loc.pathname === "/" : loc.pathname.startsWith(to);
    return (
      <Link key={to} to={to} data-testid={`bottom-${tid}`} aria-current={active ? "page" : undefined}
        className="flex flex-col items-center justify-center gap-1 flex-1 min-h-14 py-1.5">
        <Icon className={`w-[22px] h-[22px] ${active ? "text-white" : "text-slate-500"}`}
          strokeWidth={2} aria-hidden="true" />
        <span className={`text-[11px] font-medium ${active ? "text-white" : "text-slate-500"}`}>{label}</span>
      </Link>
    );
  };

  return (
    <>
      <nav data-testid="bottom-nav" aria-label="Principal"
        className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-[#0e0d14]/97 backdrop-blur-xl border-t border-white/10 pb-[max(0.4rem,env(safe-area-inset-bottom))]">
        <div className="flex items-stretch px-1 pt-1.5">
          {left.map(item)}

          <div className="w-16 flex justify-center">
            <button onClick={() => window.dispatchEvent(new CustomEvent("td:quick"))}
              data-testid="bottom-nav-fab" aria-label="Anotar algo"
              className="-mt-7 w-16 h-16 rounded-full bg-white flex items-center justify-center shadow-[0_8px_28px_-6px_rgba(0,0,0,0.6),0_0_0_5px_#0e0d14]">
              <Plus className="w-7 h-7 text-[#15141b]" strokeWidth={2.5} aria-hidden="true" />
            </button>
          </div>

          {right.map(item)}
          <button onClick={() => setMore(true)} data-testid="bottom-nav-mas"
            className="flex flex-col items-center justify-center gap-1 flex-1 min-h-14 py-1.5">
            <MoreHorizontal className="w-[22px] h-[22px] text-slate-500" strokeWidth={2} aria-hidden="true" />
            <span className="text-[11px] font-medium text-slate-500">Más</span>
          </button>
        </div>
      </nav>

      <MoreSheet open={more} onOpenChange={setMore} />
    </>
  );
}
